export const ActionTypes = {
  Email: "email",
  SMS: "sms",
  AddToAction: "add to action",
  Mqtt: "mqtt",
};

export const EventTypes = {
  NodeDataIngestError: 0,
  NodeOffline: 1,
  NodeCreated: 2,
  GatewayOffline: 3,
  GatewayCreated: 4,
  AlarmCreated: 5,
  AlarmRaised: 6,
  AlarmAcknowledged: 7,
};

export const ActionResourceTypes = {
  Node: 0,
  User: 1,
  Company: 2,
  Gateway: 3,
  Action: 4,
  Alarm: 5,
};

export const ActionResourceSubTypes = {
  ActionNode: 0,
  ActionGateway: 1,
  ActionAlarm: 2,
};

export function getResourceTypeByEventType(eventType) {
  switch (eventType) {
    case EventTypes.NodeOffline:
      return ActionResourceTypes.Node;
    case EventTypes.NodeDataIngestError:
      return ActionResourceTypes.Node;
    case EventTypes.NodeCreated:
      return ActionResourceTypes.Action;
    case EventTypes.GatewayOffline:
      return ActionResourceTypes.Gateway;
    case EventTypes.GatewayCreated:
      return ActionResourceTypes.Action;
    case EventTypes.AlarmCreated:
      return ActionResourceTypes.Action;
    case EventTypes.AlarmRaised:
      return ActionResourceTypes.Alarm;
    case EventTypes.AlarmAcknowledged:
      return ActionResourceTypes.Alarm;
    default:
      return null;
  }
}

export function filterActionsForSubType(eventType, actions) {
  const shouldUseSubType =
    eventType === EventTypes.NodeCreated ||
    eventType === EventTypes.GatewayCreated ||
    eventType === EventTypes.AlarmCreated;
  if (shouldUseSubType) {
    let actionTypesToFilter = getResourceActionTypesBySubType(
      getResourceSubTypeByEventType(eventType)
    );
    return actions.filter(
      (action) =>
        actionTypesToFilter.includes(action.eventType) &&
        action.eventType != eventType
    );
  }

  return actions;
}

export function getResourceSubTypeByEventType(eventType) {
  switch (eventType) {
    case EventTypes.NodeCreated:
      return ActionResourceSubTypes.ActionNode;
    case EventTypes.GatewayCreated:
      return ActionResourceSubTypes.ActionGateway;
    case EventTypes.AlarmCreated:
      return ActionResourceSubTypes.ActionAlarm;
    default:
      return null;
  }
}

export function getResourceActionTypesBySubType(subType) {
  switch (subType) {
    case ActionResourceSubTypes.ActionNode:
      return NodeActionTypes;
    case ActionResourceSubTypes.ActionGateway:
      return GatewayActionTypes;
    case ActionResourceSubTypes.ActionAlarm:
      return AlarmActionTypes;
    default:
      return null;
  }
}

export const NodeActionTypes = [
  EventTypes.NodeDataIngestError,
  EventTypes.NodeOffline,
  EventTypes.NodeCreated,
];

export const GatewayActionTypes = [
  EventTypes.GatewayOffline,
  EventTypes.GatewayCreated,
];

export const AlarmActionTypes = [
  EventTypes.AlarmRaised,
  EventTypes.AlarmAcknowledged,
  EventTypes.AlarmCreated,
];
